import { combineReducers } from 'redux';

import * as types from '../actions/ActionTypes';

const initialState = {
  identities: {
    login: '',
    contactId: null,
    accountType: null,
    isPro: null,
    hasPostalAddress: null,
    accountLevel: null,
    isFirstConnection: null,
    clipper: null,
  },
  selected: null,
  contacts: [],
  showLink: true,
  isFetching: true,
};

/**
 * Array user contacts with obfuscated data
 * @param state
 * @param action
 * @return {*}
 */
export const contacts = (state = initialState.contacts, action) => {
  switch (action.type) {
    case types.GET_CONTACTS_SUCCESS:
      return action.payload.contacts;
    case types.CLEAR_CONTACTS:
      return initialState.contacts;
    default:
      return state;
  }
};

/**
 * Object user identities data
 * @param state
 * @param action
 * @return {*}
 */
export const identities = (state = initialState.identities, action) => {
  switch (action.type) {
    case types.GET_IDENTITIES_SUCCESS:
      return action.payload.identities;
    default:
      return state;
  }
};

/**
 * Object selected contact used to receive OTC code
 * @param state
 * @param action
 * @return {*}
 */
export const selected = (state = initialState.selected, action) => {
  switch (action.type) {
    case types.SET_SELECTED_CONTACT:
      return action.payload.contact;
    default:
      return state;
  }
};

/**
 * Boolean link
 * @param state
 * @param action
 * @return {boolean}
 */
export const showLink = (state = initialState.showLink, action) => {
  switch (action.type) {
    case types.GET_IDENTITIES_SUCCESS:
      switch (action.payload.identities.accountLevel) {
        case 'NSRU':
          return false;
        case 'EXTERNAL':
          return false;
        default:
          return state;
      }
    default:
      return state;
  }
};

/**
 * Boolean fetching data
 * @param state
 * @param action
 * @return {boolean}
 */
const isFetching = (state = initialState.isFetching, action) => {
  switch (action.type) {
    case types.CREATE_OTP:
    case types.GET_CONTACTS:
      return true;
    case types.CREATE_OTP_FAILURE:
    case types.CREATE_OTP_SUCCESS:
    case types.GET_CONTACTS_SUCCESS:
    case types.GET_CONTACTS_FAILURE:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  identities,
  selected,
  contacts,
  showLink,
  isFetching,
});
